import type { CampaignLevelRow } from "../../shared/types/database";

export type CampaignLevelState = "completed" | "current" | "locked";

export function getCampaignLevelState(
  level: number,
  currentLevel: number,
  completedLevels: readonly number[]
): CampaignLevelState {
  if (completedLevels.includes(level) || level < currentLevel) {
    return "completed";
  }

  return level === Math.min(currentLevel, 20) ? "current" : "locked";
}

export function getInitialCampaignLevel(currentLevel: number): number {
  return Math.min(20, Math.max(1, currentLevel));
}

export function localizedEnemyName(
  level: CampaignLevelRow,
  isUzbek: boolean
): string {
  return isUzbek ? level.enemy_name_uz : level.enemy_name_ru;
}
